import styles from "src/components/molecules/MobileMenu/styles.module.css";
import { Msg } from "src/i18n/Msg";
import PromoCode from "src/assets/icons/promocode.svg";
import Settings from "src/assets/icons/settings.svg";
import Referal from "src/assets/icons/referal.svg";
import Logout from "src/assets/icons/logout.svg";
import Profile from "src/assets/icons/profile.svg";
import About from "src/assets/icons/about.svg";
import { useRedirect } from "src/navigation/useRedirect";
import { PAGES } from "src/types/navigation";
import { Button } from "src/components/atoms/Button";
import PlusIcon from "src/assets/icons/plus.svg";
import { useEffect, useRef, useState } from "react";
import { CryptoCoin } from "src/components/atoms/CryptoCoin";
import { useUserLogout } from "src/queries/useUserLogout";
import { useSelector } from "react-redux";
import { RootState } from "src/store";
import { isTelegramWebApp } from "src/utils/telegramWebApp";

type Props = {
  openDepositModal?: () => void;
  openEventModal?: () => void;
  openPromoModal?: () => void;
  openOnboardingModal?: () => void;
  close: () => void;
};

export const MobileMenu: React.FC<Props> = ({
  openDepositModal,
  close,
  openEventModal,
  openPromoModal,
  openOnboardingModal,
}) => {
  const { redirect } = useRedirect();
  const { logoutMutate } = useUserLogout();
  const isTgVersion = isTelegramWebApp();
  const [animationClass, setAnimationClass] = useState("");
  const closeTimeoutRef = useRef<number | null>(null);
  const isClosingRef = useRef(false);
  const user = useSelector((state: RootState) => state.profile.user);

  const handleClose = () => {
    if (isClosingRef.current) return;
    isClosingRef.current = true;
    setAnimationClass("closing");
    closeTimeoutRef.current = window.setTimeout(() => {
      close();
      isClosingRef.current = false;
    }, 300);
  };

  // Навигация из меню всегда закрывает шторку. Профиль и Рефералы живут в общем
  // CabinetLayout (он не размонтируется при переходе между ними), поэтому без
  // явного закрытия шторка зависала открытой — закрываем её здесь.
  const handleRedirect = (scheme: PAGES) => {
    redirect({ scheme });
    handleClose();
  };

  useEffect(() => {
    requestAnimationFrame(() => setAnimationClass("open"));

    return () => {
      if (closeTimeoutRef.current !== null) {
        window.clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  const handleOpenOnboarding = () => {
    handleClose();
    window.setTimeout(() => {
      openOnboardingModal?.();
    }, 320);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.backdrop} onClick={handleClose} role="button">
        <div
          className={`${styles.mobileMenu} ${styles[animationClass]}`}
          onClick={(event) => event.stopPropagation()}
        >
          {" "}
          <div className={styles.listWrapper}>
            <div className={styles.list}>
              <div
                className={styles.listItem}
                role="button"
                onClick={() => handleRedirect(PAGES.POSITIONS)}
              >
                <img src={Profile} alt="Profile" />
                <h5>
                  <Msg id="components.molecules.User.profile" />
                </h5>
              </div>
              <div
                className={styles.listItem}
                role="button"
                onClick={() => handleRedirect(PAGES.EDIT_PROFILE)}
              >
                <img src={Settings} alt="Settings" />
                <h5>
                  <Msg id="components.molecules.User.settings" />
                </h5>
              </div>
              <div
                className={styles.listItem}
                role="button"
                onClick={() => {
                  openPromoModal?.();
                  handleClose();
                }}
              >
                <img src={PromoCode} alt="PromoCode" />
                <h5>
                  <Msg id="components.molecules.User.promocode" />
                </h5>
              </div>
              <div
                className={styles.listItem}
                role="button"
                onClick={() => handleRedirect(PAGES.REFERALS)}
              >
                <img src={Referal} alt="Referal" />
                <h5>
                  <Msg id="components.molecules.User.referal" />
                </h5>
              </div>
              <div
                className={styles.listItem}
                role="button"
                onClick={handleOpenOnboarding}
              >
                <img src={About} alt="About stock" />
                <h5>
                  <Msg id="components.molecules.User.about" />
                </h5>
              </div>
              <div
                className={styles.balance}
                onClick={() => handleRedirect(PAGES.POSITIONS)}
              >
                <h5>
                  <Msg id="components.molecules.MobileMenu.portfolio" />
                </h5>
                <p>
                  {user?.balance?.reserved
                    ? Number(user?.balance?.reserved)
                    : "0,00 "}{" "}
                  <CryptoCoin fill="#27AE60" />
                </p>
              </div>
              <div
                className={styles.balance}
                onClick={() => handleRedirect(PAGES.POSITIONS)}
              >
                <h5>
                  <Msg id="components.molecules.MobileMenu.balance" />
                </h5>
                <p>
                  {user?.balance?.available
                    ? Number(user?.balance?.available)
                    : "0,00 "}{" "}
                  <CryptoCoin fill="#27AE60" />
                </p>
              </div>
            </div>
            <Button
              text={{ id: "components.organisms.AuthHeader.addEvenet" }}
              leftIcon={PlusIcon}
              onClick={() => {
                openEventModal?.();
              }}
            />
            <Button
              text={{ id: "components.organisms.AuthHeader.deposit" }}
              onClick={() => {
                openDepositModal?.();
              }}
            />
          </div>
          {!isTgVersion && (
            <div>
              <div
                className={styles.logout}
                role="button"
                onClick={() => logoutMutate()}
              >
                <h3>
                  <Msg id="components.molecules.User.logout" />
                </h3>
                <img src={Logout} alt="Logout" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
